import { chartLineOptions } from "../../helpers/chartoptions";
import { ArrayNumElementsAmount, concatArrays, getDangerShortName, getMinMaxBySettings, getNestedProperty, getObjectFirstPath, hasNestedProperty, round, ShowLocaleDateTime, ShowLocaleTime, ShowWindDirectInRumb } from "../../helpers/helpers";
import { PRESSURE_HG_TO_MM } from "../../helpers/Reference";
import References from "../../helpers/Reference";

const type = 'mchs';


const SOIL_TEMPERATURE_MIN = -5;
const SOIL_TEMPERATURE_MAX = 30;

export const setLineChartOptions = ( measurer, chartData, basis, userSettings ) => {  
        let chartOptions = chartLineOptions()
       
        //постоянные константы: НЯ/ОЯ 
        chartOptions.plugins.annotation.annotations = {};
        let refSettings = References[type][measurer.type].const_lines;         
        
        //некоторые измерители уставки хранят во вложенных ключах:
        //waterlevel - zero и bsv
        //hydrohydrologicalthreatzone - в двойной вложенности waterlevel.bsv
        let settings = null;
        if (measurer.hasOwnProperty('settings') && measurer.settings) {        
            settings = basis && hasNestedProperty(measurer.settings, basis) ? getNestedProperty(measurer.settings, basis) : measurer.settings
        }
    
        if (refSettings && settings) {
            let result = {};            
            for (let i in refSettings) {
                let setting = refSettings[i];

                if (settings.hasOwnProperty(i) && settings[i] !== null) {
                    result[i] = {
                        type: 'line',
                        yMin: settings[i],
                        yMax: settings[i],
                        borderColor: setting.color,
                        borderWidth: 2,
                    }
                }

            }
            chartOptions.plugins.annotation.annotations = result;            
        }        

        //устанавливаем min-max для оси y
        const chartMinMax = correctChartMinMax(
            setChartMin(chartData, measurer, basis, userSettings), 
            setChartMax(chartData, measurer, basis, userSettings)
        );
        chartOptions.scales.y.min = chartMinMax.min;
        chartOptions.scales.y.max = chartMinMax.max;

        //уровень воды - долвольно сложный расчет мин/макс, а также шаг step сетки графика по 
        if (measurer.type === 'waterlevel' || measurer.type === 'forecastwaterlevel') {
            const stepMinMax = getWaterLevelMinMaxStep(chartMinMax.min, chartMinMax.max);
            chartOptions.scales.y.min = stepMinMax.min_y;
            chartOptions.scales.y.max = stepMinMax.max_y;
            chartOptions.scales.y.ticks = {stepSize: stepMinMax.step};
        }

        //дополнение к тултипам (всплывающим подсказкам):
        //для ветра направление
        chartOptions.plugins.tooltip.callbacks = {};        //сбросить настройки от предыдущего графика
        chartOptions.plugins.tooltip.usePointStyle = false;        
        if (measurer.tooltips) {
            
            let field = null;
            switch ( measurer.type ) {
                case 'wind':

                    field = References.mchs[measurer.type].polar.polar_field;              

                    chartOptions.plugins.tooltip.usePointStyle = true;                
                    chartOptions.plugins.tooltip.callbacks = {
                        labelPointStyle: (item) => {

                            let windDirect = chartData.source[item.dataIndex][field];                            

                            let img = new Image();
                            img.src = 'data:image/svg+xml;utf8, <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve" height="15px" width="15px"><polygon fill="rgb(255, 255, 255)" points="0.056,58.263 41.85,100 83.641,58.263 83.641,45.662 46.866,77.438 46.866,0 36.611,0 36.611,77.213 0,45.605 0.056,58.263" /></svg>';

                            return {
                                pointStyle: img,
                                rotation: 1 * windDirect
                            }


                        },                                                
                        footer: function( item ) {
                            if (item.length > 0) {                                                                 
                                let dataIndex = item[0].dataIndex;     
                                let windDirect = chartData.source[dataIndex][field];
                                let footerStr = `${ShowWindDirectInRumb( windDirect )}`;
                                //если в настройках выбраны единица измерения румбы/градусы дополняем градусами
                                if (userSettings.setting_wind_unit === 'rumbs_degrees')
                                    footerStr += `, ${Math.round(windDirect)}°`
                                return footerStr
                            }
                        }                        
                    }

                break;
                case 'radiation':
                    const extField = References.mchs.radiation.extInfoField;
                    const func = References.mchs.radiation.extInfoCalc;
                    chartOptions.plugins.tooltip.callbacks = {                        
                        footer: function( item ) {
                            let dataIndex = item[0].dataIndex;                                 
                            let val = chartData.source[dataIndex][extField];
                            return  `${func(val)}%`;    

                        }   
                    }                                            

                break;

                case 'gateposition':
                    const gpField = References?.mchs?.gateposition?.extInfoField;                    
                    const gpFunc = References?.mchs?.gateposition?.extInfoCalc;
                    const gpUnit = References?.mchs?.gateposition?.extInfoUnit;

                    chartOptions.plugins.tooltip.callbacks = {                                                                        
                        footer: function(item) {
                            const dataIndex = item[0].dataIndex;
                            return `${gpFunc(chartData.source[dataIndex][gpField])}${gpUnit}`; 
                        }
                    }
                break;

                case 'soilhumidity':
                    const extInfo = References.mchs.soilhumidity.extInfo_hum;                
                    chartOptions.plugins.tooltip.callbacks = {     
                        label: function( item ) {
                            const data = chartData.length > 1 ? chartData[item.datasetIndex] : chartData;
                            return `${data.source[item.dataIndex].depth_mm / 10}${References.dictionary.soil_humidity_depth_unit}: ${item.raw}`;
                        },                   
/*                        footer: function( item ) {
                            if (!measurer?.settings?.display_value_in_percent)  {                            
                                const data = chartData.length > 1 ? chartData[item[0].datasetIndex] : chartData;                            
                                return item.map(val => {
                                    const adc1 = data.source[val.dataIndex][extInfo.field1];                            
                                    const adc2 = data.source[val.dataIndex][extInfo.field2];                            
                                    return `${extInfo.name1}: ${Math.round(adc1)}\n${extInfo.name2}: ${Math.round(adc2)}`;                                    
                                })
                            }
                        }*/
                    }                                     
                break;

                case 'soiltemperature':
                    chartOptions.plugins.tooltip.callbacks = {     
                        label: function( item ) {
                            const data = chartData.length > 1 ? chartData[item.datasetIndex] : chartData;
                            return `${data.source[item.dataIndex].depth_mm / 10}${References.dictionary.soil_temperature_depth_unit}: ${item.raw}`;
                        }
                    }                                            
                break;

            }
        }
        return chartOptions;
    }    

const getFiniteChartValues = (data) => {
    const datasets = Array.isArray(data) ? data : [data];
    return datasets.flatMap(dataset => Array.isArray(dataset?.data) ? dataset.data : [])
        .filter(value => Number.isFinite(value));
}

export const setChartMin = ( data, measurer, basis, userSettings ) => {
    let result = null;
    let min;

    const values = getFiniteChartValues(data);
    const algo = measurer.type;     
    switch (algo) {

        //min для воды
        case 'waterlevel':      
        case 'forecastwaterlevel':
            const minMax = getMinMaxBySettings( 
                basis && hasNestedProperty(measurer.settings, basis) ? getNestedProperty(measurer?.settings, basis) : measurer?.settings, 
                ['flooding_prevention', 'flooding_danger', 'draining_prevention', 'draining_danger', 'dry'], 
                values,
                basis 
            );
            //result = minMax.min - Math.abs(minMax.max - minMax.min);
            result = minMax.min;
            break;

        case 'waterleveldifference':
            min = Math.min(...values);
            result = Math.floor(min - Math.abs(min) * 0.2);
            break;                 

        case 'gateposition':
            min = Math.min(...values);                
            result = Math.floor(Math.min(0, min - Math.abs(min) * 0.1)) ;
            break;                   
            
        case 'waterdischarge2d':
        case 'waterdischargeflow':                
        case 'waterdischarge':
            min = Math.min(...values);
            result = Math.floor(min - Math.abs(min) * 0.2);
            break;                 

        case 'watervelocity':
            result = Math.max(0, Math.min(...values) - 1);
        break;                                

        //max для осадков
        case 'precipitation':
        case 'precipitationduo':
            result = 0;
            break;

        //mшт для давления
        case 'pressure':
            const pressureMin = userSettings?.setting_pressure_unit === 'gPa' ? 1060 : 670;
            result = Math.min(pressureMin, round(Math.min(...values) - 10) );
            break;

        //min для влажности
        case 'humidity':
        case 'wind':
        case 'windgust':
            result = 0;
            break;

        //min для температуры
        case 'temperature':
            result = Math.floor(Math.min(...values) - 5);
            break;

        case 'soiltemperature':
            result = Math.min(...values);
            result = result < SOIL_TEMPERATURE_MIN ? result - Math.abs(result) * 0.1 : SOIL_TEMPERATURE_MIN;                
            break;

        default:
            min = Math.min(...values);
            result = min - Math.abs(min) * 0.1;
            break;                
    }
    if (values.length === 1)
        result -= Math.abs(result) * 0.2;
    return Number.isFinite(result) ? result : 0;
}

export const setChartMax = ( data, measurer, basis, userSettings ) => {
    let result = null;
    let max, min;

    let values = getFiniteChartValues(data);
    const algo = measurer.type;
    //max для воды
    switch (algo) {

        case 'waterlevel':
        case 'forecastwaterlevel':            
            const minMax = getMinMaxBySettings( 
                basis && hasNestedProperty(measurer.settings, basis) ? getNestedProperty(measurer?.settings, basis) : measurer?.settings, 
                ['flooding_prevention', 'flooding_danger', 'draining_prevention', 'draining_danger'], 
                values,
                basis 
            );
            //result = minMax.max + Math.abs(minMax.max - minMax.min)
            result = minMax.max;
            break;

        case 'waterleveldifference':
            max = Math.max(...values);
            result = Math.ceil(max + max * 0.2);
            break;                

        case 'gateposition':
            //gate height in metres, values in cm
            const gatePosition = measurer.settings?.gate_height ? measurer.settings.gate_height * 100 : 0
            const maxValue = Math.max(...values);
            max = Math.max(gatePosition, maxValue);
            result = Math.ceil(max + max * 0.1) 
            break;

        case 'waterdischarge2d':
        case 'waterdischargeflow':                                
        case 'waterdischarge':        
            max = Math.max(...values);                
            result = Math.ceil(max + max * 0.2);
            break;                
            
        case 'watervelocity':
            result = Math.max(3, Math.max(...values) + 1);
        break;                                

        //max для осадков
        case 'precipitation':
        case 'precipitationduo':
            max = Math.max(...values);
            result = max <= 0.6 ? 1 : max + 0.4;
            break;

        //max для давления
        case 'pressure':
            const pressureMax = userSettings?.setting_pressure_unit === 'gPa' ? 1060 : 790;
            result = Math.max(pressureMax, Math.max(...values) + 10);
            break;

        //max для влажности
        case 'humidity':
            result = 100;
            break;

        //max для температуры
        case 'temperature':
            result = Math.max(50, Math.max(...values) + 5);
            break;    

        case 'gas20m':
        case 'gas24h': 
            max = measurer.settings && measurer.settings.mpc_w ?
                Math.max(measurer.settings.mpc_w, Math.max(...values))
                :
                Math.max(...values);
            min = Math.min(...values);
            result = max + (max - min ) * 0.2;
            break;   

        case 'radiation':

            max = measurer.settings && measurer.settings.radiation_danger ?
                Math.max(measurer.settings.radiation_danger, Math.max(...values))
                :
                Math.max(...values);
            min = Math.min(...values);
            result = max + (max - min ) * 0.2;
            break;                                                                      

        case 'soiltemperature':
            result = Math.max(...values);
            result = result > SOIL_TEMPERATURE_MAX ? result + Math.abs(result) * 0.1 : SOIL_TEMPERATURE_MAX;                
            break;
    

        default:
            max = Math.max(...values);
            result = max + Math.abs(max) * 0.1;
            break;                
    }
    if ( values.length === 1)
        result += Math.abs(result) * 0.2;
    return Number.isFinite(result) ? result : 5;
}

export const correctChartMinMax = ( min, max ) => {
    if (min ===0 && max === 0)
        return {
            min: 0,
            max: 1
        
        }

    if (min === max) 
        return {
            min: min - Math.abs(min * 0.2),
            max: max + Math.abs(max * 0.2)
        }

    return {
        min: min,
        max: max            
    }        
}

export const getWaterLevelMinMaxStep = (min, max) => {
    const MIN_STEP_COUNT = 5
    const OPT_STEP = 8
    const OFFSET = 0.0
    const difference = (max - min)
    var step = difference / OPT_STEP

    var digit = 0
    if (step > 1){
        var step_temp = step
        while (step_temp > 0){
            step_temp = Math.floor(step_temp / 10)
            digit += 1
        }
    }
    const pow = Math.pow(10, digit);
    if (step < 0.1 * pow)
        step = 0.1 * pow
    else if (step < 0.2 * pow)
        step = 0.2 * pow
    else if (step < 0.3 * pow)
        step = 0.3 * pow
    else
        step = Math.ceil(step / (0.5 * pow)) * (0.5 * pow)
    if (difference/step < MIN_STEP_COUNT){
        const center = (max + min)/2
        const min_number_for_calc = Math.min(center - step * Math.floor(MIN_STEP_COUNT/2), min)
        const max_number_for_calc = Math.max(center + step * Math.floor(MIN_STEP_COUNT/2), max)
        var min_y = Math.floor(min_number_for_calc/step) * step
        var max_y = Math.ceil(max_number_for_calc/step) * step
        if (min_y > min_number_for_calc)
            min_y -= step
        if (max_y < max_number_for_calc)
            min_y += step
    }
    else{
        var min_y = Math.floor(min/step) * step
        var max_y = Math.ceil(max/step) * step
        if (Math.abs(min - min_y) < step * OFFSET)
            min_y -= step
        if (Math.abs(max_y - max) < step * OFFSET)
            max_y += step
    }
    return {step: step, min_y: parseFloat(min_y.toFixed(1)), max_y: parseFloat(max_y.toFixed(1))}
}

export const getChartDatasets = ( data, measurer, basis ) => {

    const mainColor = data.hasOwnProperty('data_norm') ? "#000" : "#00a";        

    let datasets = [];
    Object.keys(data).filter(key => key === 'data' || key === 'data_norm').forEach(key => {

        const color = key === 'data_norm' ? "#0a0" : mainColor;
        datasets.push({
            fill: false,
            pointRadius: ArrayNumElementsAmount(data.data) === 1 ? 5 : 0,
            backgroundColor: color,
            borderColor: color,
            borderWidth: 1,
            spanGaps: false,
            data: data[key],
            segment: {
                borderColor: ctx => setLineSegmentColor(ctx, measurer, basis),
            }
        })
    });
    return datasets;
}

export const getGroupChartData = (data, hiddenMeasurers) => {
    const result = data.map((val, idx) => {
        return {
            fill: false,
            pointRadius: ArrayNumElementsAmount(val.data) === 1 ? 0 : 0,
            backgroundColor: References.colors[idx],
            borderColor: References.colors[idx],
            borderWidth: 1,            
            spanGaps: false,
            data: val.data,
            hidden: hiddenMeasurers.indexOf(idx) !== -1
        }        
    })
    return result;
}

const setLineSegmentColor = ( ctx, measurer, basis ) => {
    const lines = References.mchs[measurer.type].const_lines;        
    switch (measurer.type) {
        case 'waterlevel':
            if (!measurer.settings[basis])
                break;
            
            let more = ['flooding_danger', 'flooding_prevention'];
            let less = ['draining_danger', 'draining_prevention'];

            let currLevel = ctx.p1.raw;
            let prevLevel = ctx.p0.raw;

            for ( let i in more ) {
                let key = more[i];
                let limit = measurer.settings[basis][key];
                if ( Number.isFinite(limit) && (limit < currLevel || limit < prevLevel) ) {
                    return lines[key].color;
                }
            }

            for ( let i in less ) {
                let key = less[i];
                let limit = measurer.settings[basis][key];
                if ( Number.isFinite(limit) && (limit > currLevel || limit > prevLevel) ) {
                    return lines[key].color;
                }
            }
        break; 

        case 'gas20m':
        case 'gas24h':
            if (!measurer.settings)
                break;

            let moreGas = ['mpc_w', 'mpc_l'];            
            
            let currLevelGas = ctx.p1.raw;
            let prevLevelGas = ctx.p0.raw;

            for ( let i in moreGas ) {
                let key = moreGas[i];
                let limit = measurer.settings[key];
                if ( Number.isFinite(limit) && (limit < currLevelGas || limit < prevLevelGas) ) {
                    return lines[key].color;
                }
            }

        break;

        case 'radiation':
            if (!measurer.settings)
                break;

            let moreR = ['radiation_danger', 'radiation_prevention'];            
            
            let currLevelR = ctx.p1.raw;
            let prevLevelR = ctx.p0.raw;

            for ( let i in moreR ) {
                let key = moreR[i];
                let limit = measurer.settings[key];
                if ( Number.isFinite(limit) && (limit < currLevelR || limit < prevLevelR) ) {
                    return lines[key].color;
                }
            }

        break;

    }
}

export const getChartDatasetsMulti = ( data, measurer, tab ) => {

    let result = new Array();
    const tabs = References.mchs[measurer.type]?.tabs;
    const colors = tabs[tab]?.color;
    const labels = tabs[tab]?.labels;

    data.forEach((dataset, datasetIdx) => {
        const color = colors?.hasOwnProperty(datasetIdx) ? colors[datasetIdx] : References.default_chart_color;
        const label = labels?.hasOwnProperty(datasetIdx) ? labels[datasetIdx] : ""

        result.push({
            fill: false,
            label: label,
            pointRadius: ArrayNumElementsAmount(dataset) === 1 ? 5 : 0,
            backgroundColor: color,
            borderColor: color,
            borderWidth: 1,
            spanGaps: false,
            data: dataset,
            segment: {
                borderColor: ctx => setLineSegmentColor(ctx, measurer),
            }
        })
    })
    return result;
}

export const setLineChartOptionsMulti = (measurer, chartData, tab) => {
    let chartOptions = chartLineOptions()

    const chartMinMax = correctChartMinMax(
        setChartMinMulti(measurer, chartData), 
        setChartMaxMulti(measurer, chartData)
    );
    chartOptions.scales.y.min = chartMinMax.min;
    chartOptions.scales.y.max = chartMinMax.max;
       
    return chartOptions;    
}

const setChartMinMulti = ( measurer, chartData ) => {
    let result = null;
    const resultArray = concatArrays(chartData.data).filter(value => Number.isFinite(value));
    const algo = measurer.type;

    switch (algo) {
        case 'wave': 
            const min = Math.min(...resultArray);
            result = min - Math.abs(min) * 0.2;
        break;
    }
    return result;
} 

const setChartMaxMulti = ( measurer, chartData ) => {
    let result = null;
    const resultArray = concatArrays(chartData.data).filter(value => Number.isFinite(value));
    const algo = measurer.type;

    switch (algo) {
        case 'wave': 
            const max = Math.max(...resultArray);
            result = max + Math.abs(max) * 0.2;
        break;
    }
    return result;

} 

export const normalizeChartRange = (nextStart, nextFinish, fallbackStart, fallbackFinish) => {
    const isValidDate = value => value !== null && value !== undefined && value !== '' && typeof value !== 'boolean' && !Number.isNaN(new Date(value).getTime());

    return {
        start: isValidDate(nextStart) ? nextStart : fallbackStart,
        finish: isValidDate(nextFinish) ? nextFinish : fallbackFinish,
    };
};

export const SetVisibilityGroups = (mch, visibleGroups) => {
    if (!mch?.is_in_group)
        return "block";

    if (visibleGroups.indexOf(mch?.group_id) != -1)
        return "block";

    return "none";
}

export const CorrrectGroupToMch = (mch) => {
    return {
        ...mch,
        typeName: mch.typeName || mch.group_name,
        group_name: mch.group_name
    };
}

export const SetMchGroups = (mchs, groupId) => {
    const mchsInGroups = mchs.filter(val => val.is_in_group && val.group_id === groupId);
    return mchsInGroups.map(val => {
        return {
            uuid: val.uuid,
            group_id: val.group_id,
            groupName: val.group_name,
            mch_name: val?.mchs?.short_name   
        }
    })
}

export const FindFirstMchInGroup = ( mchs, groupId ) => {
    const groupMchs = mchs.filter(val => val.group_id === groupId);
    if (groupMchs.length > 0)
        return groupMchs[0];
}

export const GetWarningGroupsInStation = ( station ) => {
    const groups = station?.mchs?.map(mch => {
        if (mch.is_in_group && mch.state_code != References.dangers.normal)
            return mch.group_id;
    });
    return [...new Set(groups)];
}

export const FormatMchsIndicatorStates = ( mchs ) => {
    const states = mchs.filter(mch => mch.main);
    const result = mchs.filter(mch => !mch.main).map(mch => {
        mch.states = [];
        return mch;
    });
    states.forEach((state) => {
        const stateIndex = mchs.findIndex(mch => mch.uuid === state.main);
        result[stateIndex]["states"] ||= [];         
        result[stateIndex]["states"].push({
            state: state.level_code,
            code: state.state_code,
            name: state.typeName
        });
    })
    return result;
}

const ExtNameForPrecipitation = ( settings, reason ) => {
    if (!settings?.period || settings.period === '10M')
        return '';

    const name = new Array();

    //тип осадков
    if (settings?.precipitation_type)
        name.push(References.dictionary.precipitation_type_label[settings.precipitation_type])

    //период агрегации осадков
    name.push(References.dictionary.precipitation_agregate_label[settings.period])    

    //тип агрегации
    if (settings?.rolling && settings.rolling === "1")
        name.push(References.dictionary.preciptation_rolling_label.rolling)

    if (name.length === 0)
        return '';
    
    if (reason === 'file_name')
        return `_${name.join('_')}_`;

    if (reason === 'column_name')
        return ` (${name.join(', ') + ')'}`
}

export const GetExportFileName = ( measurer, station, settings, reason ) => {
    var extractor = '';
    if (measurer.type.indexOf('precipitation') !== -1)
        extractor = ExtNameForPrecipitation( settings, reason );
    return `${measurer.typeName}_${extractor}${reason === 'file_name' ? station.name : ''}`
}

export const GetFirstValueOfBasis = (mchType) => {
    if (References.mchs[mchType].hasOwnProperty('basis')) {
        //return Object.keys(References.mchs[mchType].basis)[0]
        return getObjectFirstPath(References.mchs[mchType].basis)
    }

    return null;
}

export const GetMeasurerLastValueByBasis = (basis, measurer, userSettings) => {
    //прогноз уровня воды
    if (measurer.type === 'forecastwaterlevel')
        return getDangerShortName(measurer.value)

    //в измерители есть разные базисы
    if (basis)
        return round(
            measurer?.mchs?.state?.last_value[References.mchs[measurer.type]?.basis[basis].field],
            References.mchs[measurer.type].precision
        )

    if (measurer.type === 'pressure') {
        const value = userSettings?.setting_pressure_unit === 'gPa' ? measurer.value : measurer.value * PRESSURE_HG_TO_MM;
        return round( value, References.mchs[measurer.type].precision )
    }         
            
    return measurer.value
}

export const GetMeasurerUnitByBasis = (basis, measurer, field, userSettings) => {
    if (basis) {
        const basisUnit = getNestedProperty(References?.mchs[measurer.type]?.basis, basis);
        return (field && basisUnit?.unit_diff?.hasOwnProperty(field)) ? basisUnit.unit_diff[field] : basisUnit.unit
    }

    if (measurer.type === 'pressure') 
        return References.pressure.units[userSettings?.setting_pressure_unit]


    return measurer.unit
}

export const ShowMeasurerLastTime = (mch) => {
    return mch.state_time ? ShowLocaleDateTime(new Date(mch.state_time)) : null;
}

export const clearForecastsData = (data) => {
    return data.filter(item => new Date(item.time) <= new Date());        
    //return data.filter(item => item.case_danger || item.case_prevention || item.danger_level || item.message || item.time_danger || item.time_max_bs || item.time_prevention);    
}

export const showForecastLabel = (time, cond, onlyTime = false) => {
    if (!time && (typeof cond !== 'number' || cond === -1))
        return '---'
    if (!time && cond === 0)
        return 'Достигнуто'
    if (!time)
        return '---'
    return onlyTime ?  ShowLocaleTime(time) : ShowLocaleDateTime(time)
}

export const showForecastTitle = (state) => {
    return typeof state === 'number' ? References.dictionary.forecast.states[state] : '---'
}

export const getLastIndexInForeacasts = (data) => {
    let index = 0;
    for (let i = data.length - 1; i >= 0; i--) {
      if (typeof data[i] === 'number' && data[i] !== null) {
        index = i;
        break;
      }
    }    
    return index;
}

export const getHeightForecastBar = (item, isCurrent) => {
    if (!Number.isFinite(item))
        return null;
    if (isCurrent)
        return 0.4;
    return 0.25;
}

export const resolveMchForChart = (mch) => {
    if (mch?.type !== 'hydrologicalthreatzone')
        return mch;

    return {
        ...mch,
        uuid: mch.mchs?.forecastwaterlevel,
        type: 'forecastwaterlevel'
    };
}

export const waterlevelBasisOptions = (mch) => {
    return Object.keys(References.mchs.waterlevel.basis)
        .filter(key => mch?.settings?.hasOwnProperty(key))
        .map(key => {
            return {
                label: References.mchs.waterlevel.basis[key].label,
                value: key
        }
    })
}

export const normalizedOptions = () => {
    return Object.keys(References.normalizes_methods).map( key => {
        return {
            label: References.normalizes_methods[key],
            value: key
        }
    })
}